import { COMPONENT_VALUE_TYPES as types, PADDING_TYPE } from 'shared/constants';

const propsSchema = [
  {
    key: 'rich_text',
    label: 'Rich Text',
    type: types.RICHTEXT,
    options: false,
  },
  {
    key: 'padding_type',
    label: 'Padding Type',
    type: types.ENUM,
    options: PADDING_TYPE,
  },
  {
    key: 'custom_padding',
    label: 'Custom Padding (px)',
    type: types.TEXT,
  },
  {
    key: 'text_line_height',
    label: 'Text Line Height',
    type: types.TEXT,
  },
];

const defaultProps = {
  rich_text: `
    <h1>RichText Component(20pt)</h1>
    <p>
      Use this component to add custom RichText to a section.(12pt)
    </p>
  `,
  padding_type: PADDING_TYPE[0],
  custom_padding: undefined,
  text_line_height: '2'
};

export default {
  title: 'Rich Text',
  id: 'RichText',
  widgetImage: '/widgetImages/Rich+text.png',
  basic: true,
  propsSchema,
  defaultProps,
};
